'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _jsonView = require('./json-view.cssm');

var _jsonView2 = _interopRequireDefault(_jsonView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A simple component that JSON.stringify's its `data` prop renders it into a
 * <pre> tag.
 */
var JsonView = function (_Component) {
  _inherits(JsonView, _Component);

  function JsonView() {
    _classCallCheck(this, JsonView);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(JsonView).apply(this, arguments));
  }

  _createClass(JsonView, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var indent = _lodash2.default.isUndefined(this.props.indent) ? 2 : this.props.indent;

      var jsonString = JSON.stringify(data, null, indent);

      return _react2.default.createElement(
        'pre',
        { className: _jsonView2.default.base },
        jsonString
      );
    }
  }]);

  return JsonView;
}(_react.Component);

JsonView.propTypes = {
  'data': _react.PropTypes.any,
  'indent': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};
exports.default = JsonView;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2pzb24tdmlldy9qc29uLXZpZXcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUtBOzs7O0FBRUE7Ozs7Ozs7Ozs7OztBQUVBOzs7O0lBSXFCLFE7Ozs7Ozs7Ozs7OzZCQVNWO0FBQUEsVUFDQyxJQURELEdBQ1UsS0FBSyxLQURmLENBQ0MsSUFERDs7QUFFUCxVQUFNLFNBQVMsaUJBQUUsV0FBRixDQUFjLEtBQUssS0FBTCxDQUFXLE1BQXpCLElBQW1DLENBQW5DLEdBQXVDLEtBQUssS0FBTCxDQUFXLE1BQWpFOztBQUVBLFVBQU0sYUFBYSxLQUFLLFNBQUwsQ0FBZSxJQUFmLEVBQXFCLElBQXJCLEVBQTJCLE1BQTNCLENBQW5COztBQUVBLGFBQ0U7QUFBQTtBQUFBLFVBQUssV0FBVyxtQkFBTyxJQUF2QjtBQUE4QjtBQUE5QixPQURGO0FBR0Q7Ozs7OztBQWxCa0IsUSxDQUNaLFMsR0FBWTtBQUNqQixVQUFRLGlCQUFVLEdBREQ7QUFFakIsWUFBVSxpQkFBVSxTQUFWLENBQW9CLENBQzVCLGlCQUFVLE1BRGtCLEVBRTVCLGlCQUFVLE1BRmtCLENBQXBCO0FBRk8sQztrQkFEQSxRO0FBbUJwQiIsImZpbGUiOiJqc29uLXZpZXcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHtcbiAgQ29tcG9uZW50LFxuICBQcm9wVHlwZXMsXG59IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IF8gZnJvbSAnbG9kYXNoJztcblxuaW1wb3J0IHN0eWxlcyBmcm9tICcuL2pzb24tdmlldy5jc3NtJztcblxuLyoqXG4gKiBBIHNpbXBsZSBjb21wb25lbnQgdGhhdCBKU09OLnN0cmluZ2lmeSdzIGl0cyBgZGF0YWAgcHJvcCByZW5kZXJzIGl0IGludG8gYVxuICogPHByZT4gdGFnLlxuICovXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBKc29uVmlldyBleHRlbmRzIENvbXBvbmVudCB7XG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgJ2RhdGEnOiBQcm9wVHlwZXMuYW55LFxuICAgICdpbmRlbnQnOiBQcm9wVHlwZXMub25lT2ZUeXBlKFtcbiAgICAgIFByb3BUeXBlcy5udW1iZXIsXG4gICAgICBQcm9wVHlwZXMuc3RyaW5nXG4gICAgXSlcbiAgfTtcblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBkYXRhIH0gPSB0aGlzLnByb3BzO1xuICAgIGNvbnN0IGluZGVudCA9IF8uaXNVbmRlZmluZWQodGhpcy5wcm9wcy5pbmRlbnQpID8gMiA6IHRoaXMucHJvcHMuaW5kZW50O1xuXG4gICAgY29uc3QganNvblN0cmluZyA9IEpTT04uc3RyaW5naWZ5KGRhdGEsIG51bGwsIGluZGVudCk7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPHByZSBjbGFzc05hbWU9e3N0eWxlcy5iYXNlfT57anNvblN0cmluZ308L3ByZT5cbiAgICApO1xuICB9XG59O1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/lib/components/json-view/json-view.js
// module id = 147
// module chunks = 0